import Place from "./Place.page";

export default Place;
